import React, { useEffect, useState } from 'react';
import { isMobile } from '@/biz/tool';
import WebModal from '@/components/web/components/Modal';
import ModalSelectPlatformContent from './ModalSelectPlatformContent';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useTranslation } from 'react-i18next';
import { usePlatformStore } from '@/hooks/usePlatformStore';
import { PlatformIconComponent } from '@/biz/platform';
import { PlatformItems } from '@/interface/common';
import { Button } from 'aha-components';
import axiosInstance from '@/apis/axiosInstance';
import { toast } from 'aha-components';
import Loading from '@/components/Loading';
import { Fade } from '@material-ui/core';

const ModalSelectPlatform: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { showSelectPlatformModal, setShowSelectPlatformModal } =
    useWebModalStore();

  return (
    <>
      <WebModal
        title={
          <div
            className={`text-[#1c2024] font-semibold font-['Geist'] leading-loose
            ${isMobile() ? 'text-xl' : 'text-2xl'}`}
          >
            {t('navbar.account.connect_social', {
              defaultValue: 'Connect social accounts'
            })}
          </div>
        }
        visible={showSelectPlatformModal}
        isShowFooter={false}
        width={isMobile() ? 342 : 810}
        handleClose={() => {
          setShowSelectPlatformModal(false);
        }}
        canClose={true}
        keepMounted={true}
      >
        <div
          className={`w-full flex-col justify-start items-start inline-flex
            ${isMobile() ? '' : ''}`}
        >
          <div className="text-[#60646c] text-xs mb-6">
            <a
              target="_blank"
              className="ml-1 underline text-[#0c67e6]"
              href="https://www.notion.so/11104daded68803fb924f34bbac22a76?pvs=25#11804daded68807d8342edb667ae343b"
              rel="noreferrer"
            >
              {t('navbar.account.learn_more', { defaultValue: 'Learn more' })}
            </a>{' '}
            {t('navbar.account.privacy_text', {
              defaultValue: 'about how we protect your privacy.'
            })}
          </div>
          <IsConnectedListDome />
          <div className={`w-full flex flex-wrap gap-x-8 gap-y-3 mt-4 mb-10`}>
            <ModalSelectPlatformContent styleType="unbind" />
          </div>
        </div>
      </WebModal>
    </>
  );
};

const IsConnectedListDome = () => {
  const { influencers, setInfluencers } = usePlatformStore();
  const [DisconnectLoadingIndex, setDisconnectLoadingIndex] = useState(-1); // -1: 任何都不加载, 其他: 加载中对应的索引
  const [getInfluencersLoading, setGetInfluencersLoading] = useState(false);
  const { showSelectPlatformModal } = useWebModalStore();

  const getInfluencersData = async () => {
    setGetInfluencersLoading(true);
    try {
      const { data } = await axiosInstance.get('/influencer/info');
      const { influencers } = data?.data || {};
      setInfluencers(influencers || []);
    } catch (error) {
      toast({
        message: 'Get data failed!',
        position: 'top-right',
        duration: 2000,
        showClose: false,
        type: 'error'
      });
    } finally {
      setGetInfluencersLoading(false);
    }
  };

  const handleDisconnect = async (platform: any, index: number) => {
    setDisconnectLoadingIndex(index);
    try {
      const { data } = await axiosInstance.post('/influencer/disconnect', {
        influencerId: platform.influencerId
      });
      if (data?.data?.success) {
        getInfluencersData();
        toast({
          message: 'Disconnect success',
          position: 'top-right',
          duration: 2000,
          showClose: false,
          type: 'success'
        });
      }
    } catch (error) {
      toast({
        message: 'Disconnect failed',
        position: 'top-right',
        duration: 2000,
        showClose: false,
        type: 'error'
      });
    } finally {
      setDisconnectLoadingIndex(-1);
    }
  };
  return (
    <div className="w-full max-h-[calc(100vh-460px)] overflow-auto flex flex-col gap-2">
      {getInfluencersLoading ? (
        <div className="w-full h-full flex justify-center items-center">
          <Loading width={90} height={90} />
        </div>
      ) : (
        <>
          {influencers?.map((platform: any, index: number) => (
            <div
              key={platform?.id}
              className="px-5 py-4 border border-[#D9D9E0] rounded-lg flex justify-between items-center"
            >
              <div className="flex gap-4 h-full justify-between items-center">
                <div className="flex pr-2 relative">
                  <img
                    className="w-[56px] h-[56px] rounded-full"
                    src={platform?.profilePictureLink}
                    alt=""
                  />
                  <div className="absolute left-[38px] bottom-[-6px] bg-[#fff] rounded-full p-[3px]">
                    <PlatformIconComponent
                      className={`${platform.platform === PlatformItems.LINKEDIN ? 'w-[18px] h-[18px]' : 'w-5 h-5 '}`}
                      platform={platform.platform}
                    />
                  </div>
                </div>
                <div className="h-full flex flex-col justify-evenly items-start">
                  <div className="text-sm font-medium text-[#09090B]">
                    {platform?.name}
                  </div>
                  <a
                    className="text-xs font-normal text-[#0c67e6] mt-2"
                    href={platform?.profileLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {platform?.username}
                  </a>
                </div>
              </div>
              <div>
                <Fade in={showSelectPlatformModal} timeout={200}>
                  <Button
                    loading={DisconnectLoadingIndex === index}
                    className="h-10"
                    onClick={() => handleDisconnect(platform, index)}
                  >
                    Disconnect
                  </Button>
                </Fade>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ModalSelectPlatform;
